<template>
  <v-select
    class="select"
    density="compact"
    variant="outlined"
    :item-title="name || 'name'"
    :item-value="value || 'id'"
    :placeholder="placeholder"
    :items="items"
    :rules="rules"
    v-model="localValue"
    hide-details="auto"
    clearable
    @update:modelValue="$emit('update:modelValue', $event)"
  />
</template>
<script>
export default {
  name: "SelectField",
  props: {
    modelValue:  { default: null },
    value:       { type: String, default: "id" },
    name:        { type: String, default: "name" },
    placeholder: { type: String, default: "" },
    items:       { type: Array,  default: () => [] },
    rules:       { type: Array,  default: () => [] },
  },
  emits: ["update:modelValue"],
  computed: {
    localValue: {
      get() { return this.modelValue; },
      set(val) { this.$emit("update:modelValue", val); },
    },
  },
};
</script>

<style lang="scss">
.select {
  .v-field__outline {
    --v-field-border-width: 0px !important;
    border: 10px !important;
    --v-field-border-opacity: 0.38;
    align-items: stretch;
    contain: layout;
    display: flex;
    padding-top: 10px;
  }

  .v-field {
    cursor: text;
    background: #ececec !important;
    font-size: 13px;
    color: #000000;
    border-radius: 8px;
  }

  .v-field:focus-within {
    cursor: text;
    background-color: #ffffff !important;
    border: 2px solid #3c5aaa !important;
    border-radius: 8px;
  }
  .v-field__input {
    padding-top: 10px !important;
  }
  .v-field--disabled {
    pointer-events: none;
    opacity: 0.8 !important;
  }
}
</style> 

